/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, lazy } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { App } from '../App'
import { ErrorsPage } from '../error/ErrorsPage'
import { LandingPage } from '../pages/landing'
import { Logout, useAuth } from '../pages/landing/auth'
import { PrivateRoutes } from './PrivateRoutes'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AboutUsPage = lazy(() => import('../pages/about-us'))
const ContactUsPage = lazy(() => import('../pages/contact-us'))

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='about' element={<AboutUsPage />} />
          <Route path='contact' element={<ContactUsPage />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/job' />} />
            </>
          ) : (
            <>
              <Route path='landing/*' element={<LandingPage />} />
              <Route path='*' element={<Navigate to='/landing' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }

